import { initContract } from '@ts-rest/core';
import { publicActivtyFeedContract } from './activityFeed.public.contract';

const c = initContract();

export const activityFeedContract = c.router(
  {
    public: publicActivtyFeedContract,
  },
  {
    pathPrefix: '/activity-feed',
    strictStatusCodes: true,
  }
);

export * from './activityFeed.public.contract';
export * from './models';

